import React, { useMemo } from 'react'

import {
    formatLogDurationDetailed,
    getLogProgressSegments,
} from '../workload.utils'
import styles from '../WorkloadDashboard.module.css'

const WorkloadLogProgress = ({ record }) => {
    const { total, segments } = useMemo(
        () => getLogProgressSegments(record),
        [record]
    )

    const barTotal = useMemo(
        () => segments.reduce((sum, s) => sum + s.ms, 0),
        [segments]
    )

    return (
        <div className={styles.logProgressCell}>
            <div
                className={styles.logProgressTrack}
                role="progressbar"
                aria-valuenow={total}
                aria-valuemin={0}
                aria-label="Time logged by project"
            >
                {segments.map((seg) => {
                    const widthPct =
                        barTotal > 0 ? (seg.ms / barTotal) * 100 : 0
                    return (
                        <span
                            key={seg.key}
                            className={styles.logProgressSegment}
                            style={{
                                width: `${widthPct}%`,
                                backgroundColor: seg.color,
                            }}
                            title={formatLogDurationDetailed(seg.ms)}
                        />
                    )
                })}
            </div>
            <span className={styles.logProgressLabel}>
                {formatLogDurationDetailed(total)}
            </span>
        </div>
    )
}

export default WorkloadLogProgress
